import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import "./testimonialsHrms.css";
import whyHrmsImage from "../../assets/service/whyHrmsImage.png";
import testimonialHrmsImg from "../../assets/service/testimonialHrmsImg.png";
import delyBites from "../../assets/hrmsLogos/Dely Bites.png";
import fitc from "../../assets/hrmsLogos/Fitc.png";
import ganesh from "../../assets/hrmsLogos/Ganesh logo1.png";
import lora from "../../assets/hrmsLogos/Iora.png";
import mallows from "../../assets/hrmsLogos/Mallows.png";
import procure from "../../assets/hrmsLogos/Procure master.png";
import taucies from "../../assets/hrmsLogos/Taucies.png";
import foodcognics from "../../assets/hrmsLogos/foodcognics.png";
import omDance from "../../assets/hrmsLogos/Om dance.png";

const TestimonialsHrms = () => {
    const testimonials = [
          {
            text:"TechCognics implemented an HRMS solution that has made managing our workforce much simpler. Attendance, payroll, and employee records are now well-organized and easy to handle, even with teams working at multiple sites.",
            name: "Vinayak Dhoot",
            role: "Ganesh Enterprises",
            image: ganesh,
        },
        {
            text:
                "TechCognics made our HR operations simple and stress-free. From attendance and payroll to employee records, everything is now well-organized and easy to manage. Their team was always available whenever we needed support.",
            name: "Neha Rajendra Tak",
            role: "FITC",
            image: fitc,
        },
        {
            text:"We are grateful to TechCognics for HRMS solution. Managing performance tracking has become seamless, saving us time and enhancing employee satisfaction.",
            name: "DelyBites Foods",
            role: "DelyBites Foods",
            image: delyBites,
        },
        {
            text:"This platform is great from an HR perspective because it is 100% automated. All HR-related tools are available, and people can save a huge amount of time and get 100% accurate data.",
            name: "Santosh Zhambre",
            role: "Procure Masster",
            image: procure,
        },
        {
            text:
                "TechCognics HRMS has simplified workforce management across our teams. Attendance, payroll, and employee records are now accurate, organized, and easy to manage.",
            name: "Taucies",
            role: "Taucies",
            image: taucies,
        },
        {
            text: "An amazing, comprehensive, and user-friendly HR platform. The platform is well-designed, reducing the administrative burden of HR departments.",
            name: 'OM Dance Academy',
            role: "OM Dance Academy",
            image: omDance,
        },
        {
            text: "TechCognics HRMS has made managing our workforce simple and efficient. Records are now accurate and easy to track.",
            name: 'Mallows',
            role: "Mallows",
            image: mallows,
        },
        {
            text:"TechCognics HRMS has brought structure to our pharma workforce management.",
            name:"Iora Lifecare Pvt Ltd.",
            role:"Iora Lifecare Pvt Ltd.",
            image: lora,
        }
    ];



    const [currentIndex, setCurrentIndex] = useState(0);

    const scrollLock = useRef(false);
    const autoSlideRef = useRef(null);

    const prevTestimonial = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? testimonials.length - 1 : prev - 1
        );
        resetAutoSlide();
    };

    const nextTestimonial = () => {
        setCurrentIndex((prev) =>
            prev === testimonials.length - 1 ? 0 : prev + 1
        );
        resetAutoSlide();
    };

    // 🔹 AUTO SLIDE
    useEffect(() => {
        startAutoSlide();
        return () => clearInterval(autoSlideRef.current);
    }, []);

    const startAutoSlide = () => {
        autoSlideRef.current = setInterval(() => {
            setCurrentIndex((prev) =>
                prev === testimonials.length - 1 ? 0 : prev + 1
            );
        }, 4000); // 4 seconds
    };

    const resetAutoSlide = () => {
        clearInterval(autoSlideRef.current);
        startAutoSlide();
    };

    // 🔹 SCROLL HANDLER (THROTTLED)
    const handleWheel = (e) => {
        if (scrollLock.current) return;

        scrollLock.current = true;

        if (e.deltaY > 0) {
            nextTestimonial();
        } else {
            prevTestimonial();
        }

        setTimeout(() => {
            scrollLock.current = false;
        }, 600);
    };

    return (
        <>
            <Helmet>
                <title>Why Choose Our HRMS Software | TechCognics</title>
                <meta
                    name="description"
                    content="Discover why businesses choose TechCognics HRMS software."
                />
            </Helmet>

            <section className="testimonial-section  bg-white">
                <div className="text-center feature-heading" style={{ color: '#0F4F93' }}>Customer Testimonials</div>

                <p className="subtitle">
                    Our clients love us, here are a few of their quotes.
                </p>

                <div className="testimonial-wrapper" onWheel={handleWheel}>
                    <div className="testimonial-image">
                        <img src={testimonialHrmsImg} alt="Clients Map" />
                    </div>

                    <div className="testimonial-slider">
                        {/* CARD */}
                        <div className="testimonial-card mx-2"   style={{ height: "clamp(300px, 30vh, 350px)" }}>
                            <p className="text-start">{testimonials[currentIndex].text}</p>

                            <div className="testimonial-footer">
                                <img
                                    src={testimonials[currentIndex].image}
                                    alt={testimonials[currentIndex].name}
                                />
                                <div className="text-start fw-bold">
                                    <span className="name">
                                        {testimonials[currentIndex].name}
                                    </span>
                                    <span className="role fw-bold">
                                        {testimonials[currentIndex].role}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* ARROWS */}
                        <div className="slider-arrows">
                            <button
                                className="arrow-btn prev"
                                onClick={prevTestimonial}
                                aria-label="Previous testimonial"
                            >
                                &#10094;
                            </button>
                            <button
                                className="arrow-btn next"
                                onClick={nextTestimonial}
                                aria-label="Next testimonial"
                            >
                                &#10095;
                            </button>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

export default TestimonialsHrms;
